import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const CompanyAnnouncementSidePanel = ({ show, onHide, title, children }) => {
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        onHide();
      }
    };

    if (show) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [show, onHide]);

  return (
    <div className={`custom-side-panel ${show ? 'open' : ''}`}>
      <div className="header">
        <span className="title">{title}</span>
        <button type="button" className="close-btn" onClick={onHide}>
          ×
        </button>
      </div>
      <div className="body">{children}</div>
    </div>
  );
};

CompanyAnnouncementSidePanel.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node
};

CompanyAnnouncementSidePanel.defaultProps = {
  title: '',
  children: null
};

export default CompanyAnnouncementSidePanel;
